import React from "react";
import PatientChronicComponent from "@components/User/Chronic/PatientChronic";

export default function PatientChronic() {
  return <PatientChronicComponent />;
}
